import { render, staticRenderFns } from "./ReciveMoney.vue?vue&type=template&id=64831231&scoped=true&"
import script from "./ReciveMoney.vue?vue&type=script&lang=js&"
export * from "./ReciveMoney.vue?vue&type=script&lang=js&"
import style0 from "./ReciveMoney.vue?vue&type=style&index=0&id=64831231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64831231",
  null
  
)

export default component.exports